export const MOBILE_APP_BANNER_TITLE = 'В_приложении_уже_есть_отзывы_105';
